// Centralised, typed access to the runtime config (all from import.meta.env).
//
// Vite inlines VITE_* at build time. We read them ONCE here and export a
// frozen object so the rest of the app never touches import.meta.env
// directly — easier to mock, and one place to see every knob.
//
// This is the standalone admin portal: the ONLY backend it talks to is
// admin-svc, so the only knob is its base URL.

function str(v: string | undefined, fallback = ''): string {
  return (v ?? '').trim() || fallback;
}

const env = import.meta.env;

export const config = Object.freeze({
  // admin-svc BFF (the staff Admin section — Filament replacement). Empty base
  // ⇒ same-origin (dev proxy forwards /v1/admin). In prod set the public URL,
  // e.g. https://admin-api.telride.com.au. There is NO baked-in secret — staff
  // log in with email+password and get a JWT (see adminAuth.ts).
  adminBaseUrl: str(env.VITE_ADMIN_BASE_URL).replace(/\/+$/, ''),
});

export type AppConfig = typeof config;
